import styled from "styled-components";
var FormGroup = styled.div.withConfig({
  displayName: "FormGroup",
  componentId: "sc-c69av-0"
})(["width:", "%;flex:0 1 auto;margin-bottom:20px;position:relative;margin-right:10px;&:last-of-type{margin-right:0;margin-bottom:0;}"], function (props) {
  return (props.width || 1) * 100;
});
export default FormGroup;